import React from "react";
import { FaBootstrap, FaGithub, FaReact } from "react-icons/fa";
import { BsArrowRight } from "react-icons/bs";
import { TbBrandJavascript } from "react-icons/tb";
import { AiOutlineHtml5 } from "react-icons/ai";
import { SiCss3 } from "react-icons/si";
import ImgCard1 from "../../assets/imgPortfolio1.png";
import ImgCard2 from "../../assets/imgPortfolio2.png";
import ImgCard3 from "../../assets/imgPortfolio3.png";
import ImgCard4 from "../../assets/imgPortfolio4.png";
import { SiTailwindcss } from "react-icons/si";

export const Portfolio = () => {
  return (
    <div className="h-full w-screen bg-white" id="portfolio">
      <div className="container px-5 py-24 mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-3xl text-[#007ec3f] font-semibold">
            Portfólio
          </h1>
          <h5 className="text-base md:text-lg mb-1">Conheça meus projetos</h5>
        </div>

        <div className="flex flex-wrap -m-4">
          <div className="p-4 sm:w-1/2 lg:w-1/3">
            <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
              <img
                src={ImgCard1}
                alt="/"
                className="lg:h-72 md:h-48 w-full object-cover object-center"
              />
              <div className="p-6 transition duration-300 ease-in bg-white">
                <h2 className="text-base font-medium text-indigo-300 mb-1">
                  October - 2022.
                </h2>
                <h1 className="text-2xl font-semibold mb-3">ZM Signs</h1>
                <p className="leading-relaxed mb-3">
                  Projeto desenvolvido com:
                </p>
                <p className="flex flex-row">
                  <FaReact /> <span className="ml-4">React</span>
                </p>
                <p className="flex flex-row">
                  <SiTailwindcss /> <span className="ml-4">Tailwindcss</span>
                </p>
                <p className="flex flex-row">
                  <FaGithub /> <span className="ml-4">Github</span>
                </p>
                <div className="flex justify-between items-center flex-wrap">
                  <a
                    href="https://zmsigns.vercel.app/"
                    className="text-indigo-300 inline-flex items-center md:mb-2 lg:mb-0"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    Ver Projeto{" "}
                    <BsArrowRight className="hover:translate-x-3 duration-300" />
                  </a>
                  <a
                    href="https://github.com/Jtomio/react-zorzin-portfolio/tree/main/src"
                    className="text-indigo-300 inline-flex items-center md:mb-2 lg:mb-0 "
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    Ver Repositório{" "}
                    <BsArrowRight className="hover:translate-x-3 duration-300" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="p-4 sm:w-1/2 lg:w-1/3">
            <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
              <img
                src={ImgCard2}
                alt="/"
                className="lg:h-72 md:h-48 w-full object-cover object-center"
              />
              <div className="p-6 transition duration-300 ease-in bg-white">
                <h2 className="text-base font-medium text-indigo-300 mb-1">
                  Agosto - 2022.
                </h2>
                <h1 className="text-2xl font-semibold mb-3">Transport Alex</h1>
                <p className="leading-relaxed mb-3">
                  Projeto desenvolvido com:
                </p>
                <p className="flex flex-row">
                  <FaReact /> <span className="ml-4">React</span>
                </p>
                <p className="flex flex-row">
                  <FaBootstrap /> <span className="ml-4">BootStrap</span>
                </p>
                <p className="flex flex-row">
                  <FaGithub /> <span className="ml-4">Github</span>
                </p>
                <div className="flex justify-between items-center flex-wrap">
                  <a
                    href="https://transportetioalex.netlify.app/"
                    className="text-indigo-300 inline-flex items-center md:mb-2 lg:mb-0 "
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    Ver Projeto{" "}
                    <BsArrowRight className="hover:translate-x-3 duration-300" />
                  </a>
                  <a
                    href="https://transportetioalex.netlify.app/"
                    className="text-indigo-300 inline-flex items-center md:mb-2 "
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    Ver Repositório{" "}
                    <BsArrowRight className="hover:translate-x-3 duration-300" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="p-4 sm:w-1/2 lg:w-1/3">
            <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
              <img
                src={ImgCard3}
                alt="/"
                className="lg:h-72 md:h-48 w-full object-cover object-center"
              />
              <div className="p-6 transition duration-300 ease-in bg-white">
                <h2 className="text-base font-medium text-indigo-300 mb-1">
                  Dezembro - 2022.
                </h2>
                <h1 className="text-2xl font-semibold mb-3">
                  VISEG Treinamentos
                </h1>
                <p className="leading-relaxed mb-3">
                  Projeto desenvolvido com:
                </p>
                <p className="flex flex-row">
                  <FaReact /> <span className="ml-4">React</span>
                </p>
                <p className="flex flex-row">
                  <SiTailwindcss /> <span className="ml-4">Tailwindcss</span>
                </p>
                <p className="flex flex-row">
                  <FaGithub /> <span className="ml-4">Github</span>
                </p>
                <div className="flex justify-between items-center flex-wrap">
                  <a
                    href="https://viseg.com.br/"
                    className="text-indigo-300 inline-flex items-center md:mb-2 lg:mb-0 "
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    Ver Projeto{" "}
                    <BsArrowRight className="hover:translate-x-3 duration-300" />
                  </a>
                  <a
                    href="https://github.com/Jtomio/portfolio-vsviseg"
                    className="text-indigo-300 inline-flex items-center mr-3 "
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    Ver Repositório{" "}
                    <BsArrowRight className="hover:translate-x-3 duration-300" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="p-4 sm:w-1/2 lg:w-1/3">
            <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
              <img
                src={ImgCard4}
                alt="/"
                className="lg:h-72 md:h-48 w-full object-cover object-center"
              />
              <div className="p-6 transition duration-300 ease-in bg-white">
                <h2 className="text-base font-medium text-indigo-300 mb-1">
                  Julho - 2022.
                </h2>
                <h1 className="text-2xl font-semibold mb-3">
                  Consulta Clima API
                </h1>
                <p className="leading-relaxed mb-3">
                  Projeto desenvolvido com:
                </p>
                <p className="flex flex-row">
                  <AiOutlineHtml5 /> <span className="ml-4">React</span>
                </p>
                <p className="flex flex-row">
                  <SiCss3 /> <span className="ml-4">CSS</span>
                </p>
                <p className="flex flex-row">
                  <TbBrandJavascript /> <span className="ml-4">Javascript</span>
                </p>
                <div className="flex justify-between items-center flex-wrap">
                  <a
                    href="https://climagora.netlify.app/"
                    className="text-indigo-300 inline-flex items-center md:mb-2 lg:mb-0 "
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    Ver Projeto{" "}
                    <BsArrowRight className="hover:translate-x-3 duration-300" />
                  </a>
                  <a
                    href="https://github.com/Jtomio/ConsultaClima"
                    className="text-indigo-300 inline-flex items-center mr-3 "
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    Ver Repositório{" "}
                    <BsArrowRight className="hover:translate-x-3 duration-300" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
